import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as CommonFunctions from "../functions/commonFunctions";
import * as GC from "../../../../common/common";

class CreateManagementUnit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      code: "",
      wetenschappelijke: "",
      nederlandse: "",
      soort: "",
      startPeriode: "",
      eindePeriode: "",
      wet: "",
      naamPeriode: "",
      omschrijving: "",
      active: true,
      codeRequiredAlert: false,
      wetenschappelijkeRequiredAlert: false,
      nederlandseRequiredAlert: false,
      soortRequiredAlert: false,
      eindePeriodeRequiredAlert: false,
      startPeriodeRequiredAlert: false,
      wetRequiredAlert: false,
      naamPeriodeRequiredAlert: false,
      omschrijvingRequiredAlert: false,
    };
    this.baseState = this.state;
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  resetForm = async () => {
    await this.setState(this.baseState);
  };

  addParentFolder(childId) {
    var that = this;
    var parentId = $("#tree-parent-id").val();
    var model = { folder: parentId };

    omnimap
      .AddParentFolderAction(
        model,
        childId,
        window.$catalog_management_units_token
      )
      .then((result) => {
        console.log(result);
      });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    if (value != "" && name == "code") {
      this.setState({ codeRequiredAlert: false });
    }
    if (value != "" && name == "wetenschappelijke") {
      this.setState({ wetenschappelijkeRequiredAlert: false });
    }
    if (value != "" && name == "nederlandse") {
      this.setState({ nederlandseRequiredAlert: false });
    }
    if (value != "" && name == "soort") {
      this.setState({ soortRequiredAlert: false });
    }
    if (value != "" && name == "startPeriode") {
      this.setState({ eindePeriodeRequiredAlert: false });
    }
    if (value != "" && name == "eindePeriode") {
      this.setState({ eindePeriodeRequiredAlert: false });
    }
    if (value != "" && name == "wet") {
      this.setState({ wetRequiredAlert: false });
    }
    if (value != "" && name == "naamPeriode") {
      this.setState({ naamPeriodeRequiredAlert: false });
    }
    if (value != "" && name == "omschrijving") {
      this.setState({ omschrijvingRequiredAlert: false });
    }
  }

  async handleSubmit(event) {
    event.preventDefault();
    $("#cover-spin").show(0);

    this.state.code == ""
      ? await this.setState({ codeRequiredAlert: true })
      : await this.setState({ codeRequiredAlert: false });
    this.state.wetenschappelijke == ""
      ? await this.setState({ wetenschappelijkeRequiredAlert: true })
      : await this.setState({ wetenschappelijkeRequiredAlert: false });
    this.state.nederlandse == ""
      ? await this.setState({ nederlandseRequiredAlert: true })
      : await this.setState({ nederlandseRequiredAlert: false });
    this.state.soort == ""
      ? await this.setState({ soortRequiredAlert: true })
      : await this.setState({ soortRequiredAlert: false });
    this.state.eindePeriode == ""
      ? await this.setState({ eindePeriodeRequiredAlert: true })
      : await this.setState({ eindePeriodeRequiredAlert: false });
    this.state.startPeriode == ""
      ? await this.setState({ startPeriodeRequiredAlert: true })
      : await this.setState({ startPeriodeRequiredAlert: false });
    this.state.wet == ""
      ? await this.setState({ wetRequiredAlert: true })
      : await this.setState({ wetRequiredAlert: false });
    this.state.naamPeriode == ""
      ? await this.setState({ naamPeriodeRequiredAlert: true })
      : await this.setState({ naamPeriodeRequiredAlert: false });
    this.state.omschrijving == ""
      ? await this.setState({ omschrijvingRequiredAlert: true })
      : await this.setState({ omschrijvingRequiredAlert: false });
    var model = {
      relationships: { definition: { code: "NATUURBESCHERMING" } },
      content: {
        algemeen: {
          actief: this.state.active,
          code: this.state.code,
          wetenschappelijkenaam: this.state.wetenschappelijke,
          nederlandsenaam: this.state.nederlandse,
          soort: this.state.soort,
          eindeperiode: this.state.eindePeriode,
          startperiode: this.state.startPeriode,
          wet: this.state.wet,
          naamperiode: this.state.naamPeriode,
          omschrijving: this.state.omschrijving,
        },
      },
    };

    let isUnique = true;
    let uniqueModel = {
      content: [
        {
          and_or: "AND",
          datatype: "STRING",
          key: "algemeen-code",
          values: [this.state.code],
        },
      ],
      definitions: [process.env.REACT_APP_CATALOG_NATURE_PROTECTION],
      sorting: [],
    };

    //** code isunique control.
    await omnimap
      .FillTableAction(uniqueModel, 1, window.$catalog_management_units_token)
      .then((result) => {
        if (result.data && result.data.length > 0) {
          isUnique = false;
          this.setState({
            codeRequiredAlert: true,
            codeAlertText: "is not unique",
          });
        }
      });

    if (
      !this.state.codeRequiredAlert &&
      !this.state.wetenschappelijkeRequiredAlert &&
      !this.state.nederlandseRequiredAlert &&
      !this.state.soortRequiredAlert &&
      !this.state.eindePeriodeRequiredAlert &&
      !this.state.startPeriodeRequiredAlert &&
      !this.state.wetenschappelijkeRequiredAlert &&
      !this.state.naamPeriodeRequiredAlert &&
      !this.state.omschrijvingRequiredAlert &&
      isUnique === true
    ) {
      var data = await omnimap.SaveOrEditAction(
        model,
        "POST",
        "",
        window.$catalog_management_units_token
      );
      if (data.result.status === "OK") {
        CallBackFunctions.beheereenheidSavedCallBack();
      }
    } else {
      $("#cover-spin").hide(0);
    }
  }

  async componentDidMount() {
    var that = this;
    $(document).on("click", "#natuurbescherming_toevoegen", function () {
      $("#natuurbescherming_toevoegen_modal").modal("show");
      CommonFunctions.GetColumnProperties("create");

      // that.resetForm();
    });
  }

  render() {
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="natuurbescherming_toevoegen_modal"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Nieuwe natuurbeschermingssoort</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <label
                className={
                  this.state.codeRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Code *
              </label>
              <label
                className={
                  this.state.codeRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                verplicht veld
              </label>
              <input
                type="input"
                className="form-control"
                name="code"
                value={this.state.code}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label
                className={
                  this.state.wetenschappelijkeRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Wetenschappelijke naam *
              </label>
              <label
                className={
                  this.state.wetenschappelijkeRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                verplicht veld
              </label>
              <input
                type="input"
                className="form-control"
                name="wetenschappelijke"
                value={this.state.wetenschappelijke}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label
                className={
                  this.state.nederlandseRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Nederlandse naam *
              </label>
              <label
                className={
                  this.state.nederlandseRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                verplicht veld
              </label>
              <input
                type="input"
                className="form-control"
                name="nederlandse"
                value={this.state.nederlandse}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label
                className={
                  this.state.soortRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Soort *
              </label>
              <label
                className={
                  this.state.soortRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                verplicht veld
              </label>
              <input
                type="input"
                className="form-control"
                name="soort"
                value={this.state.soort}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label
                className={
                  this.state.startPeriodeRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Start periode *
              </label>
              <label
                className={
                  this.state.startPeriodeRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                verplicht veld
              </label>
              <input
                type="input"
                className="form-control"
                name="startPeriode"
                value={this.state.startPeriode}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label
                className={
                  this.state.eindePeriodeRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Einde periode *
              </label>
              <label
                className={
                  this.state.eindePeriodeRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                verplicht veld
              </label>
              <input
                type="input"
                className="form-control"
                name="eindePeriode"
                value={this.state.eindePeriode}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label
                className={
                  this.state.wetRequiredAlert ? "modale-submit-alert-block" : ""
                }
              >
                Wet *
              </label>
              <label
                className={
                  this.state.wetRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                verplicht veld
              </label>
              <select
                id="nature-protection-wet"
                className="form-control"
                name="wet"
                value={this.state.wet}
                onChange={this.handleInputChange}
              ></select>
              <label
                className={
                  this.state.naamPeriodeRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Naam periode *
              </label>
              <label
                className={
                  this.state.naamPeriodeRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                verplicht veld
              </label>
              <input
                type="input"
                className="form-control"
                name="naamPeriode"
                value={this.state.naamPeriode}
                onChange={this.handleInputChange}
                autocomplete="off"
              />
              <label
                className={
                  this.state.omschrijvingRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Omschrijving *
              </label>
              <label
                className={
                  this.state.omschrijvingRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                verplicht veld
              </label>
              <input
                type="input"
                className="form-control"
                name="omschrijving"
                value={this.state.omschrijving}
                onChange={this.handleInputChange}
                autocomplete="off"
              />

              <label>Actief</label>
              <label className="switch">
                <input
                  id="beheereenheid_active"
                  type="checkbox"
                  defaultChecked
                  name="active"
                  value={this.state.active}
                  onChange={this.handleInputChange}
                />
                <span className="slider-checkbox round" />
              </label>
              <br />
              <br />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn-modal"
                onClick={this.handleSubmit.bind(this)}
              >
                Verwerken
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateManagementUnit;
